// Churchill DSCR Rate Data - Updated from Rate Sheet 5.11.26
// This data is used as default and can be overridden by admin CSV uploads

// ============================================================================
// DSCR BASE PROGRAM - Updated May 2026
// ============================================================================
export const DSCR_BASE_RATES = {
  programName: "DSCR Base",
  productTypes: ["30Y Fixed", "5/6 ARM"],
  rateMatrix: {
    "30Y Fixed": [
      { rate: 9.125, price: 107.938 },
      { rate: 9.000, price: 107.688 },
      { rate: 8.875, price: 107.438 },
      { rate: 8.750, price: 107.188 },
      { rate: 8.625, price: 106.938 },
      { rate: 8.500, price: 106.688 },
      { rate: 8.375, price: 106.438 },
      { rate: 8.250, price: 106.188 },
      { rate: 8.125, price: 105.938 },
      { rate: 8.000, price: 105.688 },
      { rate: 7.875, price: 105.438 },
      { rate: 7.750, price: 105.188 },
      { rate: 7.625, price: 104.938 },
      { rate: 7.500, price: 104.625 },
      { rate: 7.375, price: 104.250 },
      { rate: 7.250, price: 103.875 },
      { rate: 7.125, price: 103.406 },
      { rate: 7.000, price: 102.844 },
      { rate: 6.875, price: 102.281 },
      { rate: 6.750, price: 101.625 },
      { rate: 6.625, price: 100.875 },
      { rate: 6.500, price: 100.125 },
      { rate: 6.375, price: 99.375 },
      { rate: 6.250, price: 98.625 },
      { rate: 6.125, price: 97.875 },
      { rate: 6.000, price: 97.125 },
    ],
    "5/6 ARM": [
      { rate: 9.125, price: 108.138 },
      { rate: 9.000, price: 107.888 },
      { rate: 8.875, price: 107.638 },
      { rate: 8.750, price: 107.388 },
      { rate: 8.625, price: 107.138 },
      { rate: 8.500, price: 106.888 },
      { rate: 8.375, price: 106.638 },
      { rate: 8.250, price: 106.388 },
      { rate: 8.125, price: 106.138 },
      { rate: 8.000, price: 105.888 },
      { rate: 7.875, price: 105.638 },
      { rate: 7.750, price: 105.388 },
      { rate: 7.625, price: 105.138 },
      { rate: 7.500, price: 104.875 },
      { rate: 7.375, price: 104.550 },
      { rate: 7.250, price: 104.225 },
      { rate: 7.125, price: 103.806 },
      { rate: 7.000, price: 103.294 },
      { rate: 6.875, price: 102.781 },
      { rate: 6.750, price: 102.125 },
      { rate: 6.625, price: 101.375 },
      { rate: 6.500, price: 100.625 },
      { rate: 6.375, price: 99.875 },
      { rate: 6.250, price: 99.125 },
      { rate: 6.125, price: 98.375 },
      { rate: 6.000, price: 97.625 },
    ],
  },
};

// LTV brackets for LLPA lookups
export const LTV_BRACKETS = ["50%", "55%", "60%", "65%", "70%", "75%", "80%"];

// ============================================================================
// SINGLE PROPERTY LLPA MATRIX (FICO by LTV)
// ============================================================================
export const SINGLE_PROPERTY_FICO_LTV = {
  "760+": { "50%": 1.000, "55%": 1.000, "60%": 1.000, "65%": 1.000, "70%": 0.750, "75%": 0.125, "80%": -0.625 },
  "740-759": { "50%": 1.000, "55%": 1.000, "60%": 0.875, "65%": 0.875, "70%": 0.375, "75%": -0.125, "80%": -1.375 },
  "720-739": { "50%": 0.750, "55%": 0.750, "60%": 0.625, "65%": 0.500, "70%": 0.000, "75%": -0.750, "80%": -2.625 },
  "700-719": { "50%": 0.125, "55%": 0.000, "60%": -0.375, "65%": -0.625, "70%": -1.125, "75%": -1.250, "80%": -3.500 },
  "680-699": { "50%": -0.250, "55%": -0.375, "60%": -0.875, "65%": -1.375, "70%": -2.125, "75%": -3.250, "80%": -5.500 },
  "660-679": { "50%": -0.875, "55%": -1.250, "60%": -2.000, "65%": -2.625, "70%": -3.000, "75%": -4.250, "80%": "N/A" },
  "FN": { "50%": 0.125, "55%": 0.000, "60%": -0.375, "65%": -0.625, "70%": "N/A", "75%": "N/A", "80%": "N/A" },
};

// ============================================================================
// CROSSED PROPERTY LLPA MATRIX (FICO by LTV)
// ============================================================================
export const CROSSED_PROPERTY_FICO_LTV = {
  "760+": { "50%": 0.875, "55%": 0.875, "60%": 0.875, "65%": 0.875, "70%": 0.625, "75%": 0.000, "80%": "N/A" },
  "740-759": { "50%": 0.875, "55%": 0.875, "60%": 0.750, "65%": 0.750, "70%": 0.250, "75%": -0.250, "80%": "N/A" },
  "720-739": { "50%": 0.625, "55%": 0.625, "60%": 0.500, "65%": 0.375, "70%": -0.125, "75%": -0.875, "80%": "N/A" },
  "700-719": { "50%": 0.000, "55%": -0.125, "60%": -0.500, "65%": -0.750, "70%": -1.250, "75%": "N/A", "80%": "N/A" },
  "680-699": { "50%": -0.375, "55%": -0.500, "60%": -1.000, "65%": -1.500, "70%": -2.250, "75%": "N/A", "80%": "N/A" },
  "FN": { "50%": 0.000, "55%": -0.125, "60%": -0.500, "65%": "N/A", "70%": "N/A", "75%": "N/A", "80%": "N/A" },
};

// ============================================================================
// PROPERTY TYPE LLPA (by LTV)
// ============================================================================
export const PROPERTY_TYPE_LTV = {
  "Single Family": { "50%": 0.000, "55%": 0.000, "60%": 0.000, "65%": 0.000, "70%": 0.000, "75%": 0.000, "80%": 0.000 },
  "Condo": { "50%": -0.250, "55%": -0.250, "60%": -0.250, "65%": -0.250, "70%": -0.500, "75%": -0.500, "80%": -0.500 },
  "2-4 Unit": { "50%": -0.125, "55%": -0.125, "60%": -0.125, "65%": -0.375, "70%": -0.750, "75%": -1.000, "80%": -2.000 },
  "Short Term Rental": { "50%": -1.250, "55%": -1.250, "60%": -1.500, "65%": -1.750, "70%": -2.000, "75%": -2.500, "80%": "N/O" },
  "Multi Family (up to 10)": { "50%": -3.000, "55%": -3.000, "60%": -4.250, "65%": -4.500, "70%": -6.250, "75%": -6.500, "80%": "N/O" },
};

// ============================================================================
// LOAN AMOUNT LLPA (by LTV)
// ============================================================================
export const LOAN_AMOUNT_LTV = {
  "<150,000": { "50%": -1.000, "55%": -1.000, "60%": -1.000, "65%": -1.500, "70%": -1.500, "75%": -1.500, "80%": -1.750 },
  "<250,000": { "50%": 0.000, "55%": 0.000, "60%": 0.000, "65%": 0.000, "70%": -0.125, "75%": -0.125, "80%": -0.250 },
  ">1,000,000": { "50%": 0.000, "55%": 0.000, "60%": 0.000, "65%": 0.000, "70%": -0.125, "75%": -0.125, "80%": -0.125 },
  ">1,500,000": { "50%": -0.125, "55%": -0.125, "60%": -0.250, "65%": -0.250, "70%": -0.375, "75%": -0.500, "80%": -1.500 },
  ">2,000,000": { "50%": -0.125, "55%": -0.125, "60%": -0.250, "65%": -0.375, "70%": -0.500, "75%": -1.500, "80%": -2.500 },
  ">2,500,000": { "50%": -0.375, "55%": -0.375, "60%": -0.375, "65%": -0.500, "70%": -0.750, "75%": "N/O", "80%": "N/O" },
  ">2,500,000 (Crossed)": { "50%": -0.125, "55%": -0.125, "60%": -0.250, "65%": -0.250, "70%": -0.375, "75%": -0.500, "80%": "N/O" },
};

// ============================================================================
// PRODUCT/LOAN PURPOSE LLPA (by LTV)
// ============================================================================
export const PRODUCT_PURPOSE_LTV = {
  "Interest-Only": { "50%": -0.250, "55%": -0.250, "60%": -0.250, "65%": -0.250, "70%": -0.250, "75%": -0.500, "80%": "N/O" },
  "Refinance (Rate and Term)": { "50%": 0.000, "55%": 0.000, "60%": -0.250, "65%": -0.625, "70%": -1.000, "75%": -1.625, "80%": -2.125 },
  "Refinance (Cash Out)": { "50%": 0.000, "55%": 0.000, "60%": -0.250, "65%": -0.625, "70%": -1.000, "75%": -1.625, "80%": "N/O" },
  "Foreign National": { "50%": -1.250, "55%": -1.250, "60%": -1.250, "65%": -1.250, "70%": -1.750, "75%": -2.000, "80%": "N/O" },
};

// ============================================================================
// DSCR LLPA (by LTV)
// ============================================================================
export const DSCR_LTV = {
  "<1.00x": { "50%": -1.000, "55%": -1.000, "60%": -1.250, "65%": -1.500, "70%": -1.750, "75%": -2.000, "80%": "N/O" },
  "1.00-1.14x": { "50%": -0.500, "55%": -0.500, "60%": -0.500, "65%": -0.500, "70%": -0.500, "75%": -0.500, "80%": -0.500 },
  ">=1.15": { "50%": 0.250, "55%": 0.250, "60%": 0.250, "65%": 0.250, "70%": 0.250, "75%": 0.250, "80%": 0.250 },
};

// ============================================================================
// PREPAYMENT PENALTY LLPA (by LTV)
// ============================================================================
export const PREPAY_PENALTY_LTV = {
  "No Penalty": { "50%": -1.500, "55%": -1.500, "60%": -1.500, "65%": -1.500, "70%": -1.500, "75%": -1.500, "80%": -1.500 },
  "12 Months": { "50%": -1.000, "55%": -1.000, "60%": -1.000, "65%": -1.000, "70%": -1.000, "75%": -1.000, "80%": -1.000 },
  "24 Months": { "50%": -0.500, "55%": -0.500, "60%": -0.500, "65%": -0.500, "70%": -0.500, "75%": -0.500, "80%": -0.500 },
  "36 Months": { "50%": 0.000, "55%": 0.000, "60%": 0.000, "65%": 0.000, "70%": 0.000, "75%": 0.000, "80%": 0.000 },
  "48 Months": { "50%": 0.250, "55%": 0.250, "60%": 0.250, "65%": 0.250, "70%": 0.250, "75%": 0.250, "80%": 0.250 },
  "60 Months": { "50%": 0.500, "55%": 0.500, "60%": 0.500, "65%": 0.500, "70%": 0.500, "75%": 0.500, "80%": 0.500 },
};

// ============================================================================
// LEGACY LLPA STRUCTURE (for backward compatibility)
// ============================================================================
export const DSCR_BASE_LLPA = {
  // FICO adjustments (uses 70% LTV as default reference)
  fico: {
    "760+": 0.750,
    "740-759": 0.375,
    "720-739": 0.000,
    "700-719": -1.125,
    "680-699": -2.125,
    "660-679": -3.000,
  },
  // Property Type adjustments (uses 70% LTV as default reference)
  propertyType: {
    "Single Family": 0.000,
    "Condo": -0.500,
    "2-4 Unit": -0.750,
    "Short Term Rental": -2.000,
    "Multi Family (up to 10)": -6.250,
  },
  // Loan Purpose adjustments (uses 70% LTV as default reference)
  loanPurpose: {
    "Purchase": 0,
    "Rate/Term Refinance": -1.000,
    "Cash-Out Refinance": -1.000,
  },
  // DSCR adjustments (uses 70% LTV as default reference)
  dscr: {
    ">=1.15": 0.250,
    "1.00-1.14x": -0.500,
    "<1.00x": -1.750,
  },
  // Prepayment Penalty adjustments
  prepayPenalty: {
    "No Penalty": -1.500,
    "12 Months": -1.000,
    "24 Months": -0.500,
    "36 Months": 0.000,
    "48 Months": 0.250,
    "60 Months": 0.500,
  },
  // Loan Amount adjustments (uses 70% LTV as default reference)
  loanAmount: {
    "<150,000": -1.500,
    "<250,000": -0.125,
    "250,000-1,000,000": 0,
    ">1,000,000": -0.125,
    ">1,500,000": -0.375,
    ">2,000,000": -0.500,
    ">2,500,000": -0.750,
  },
  // Interest Only adjustment (uses 70% LTV as default reference)
  interestOnly: -0.250,
  // Foreign National adjustment (uses 70% LTV as default reference)
  foreignNational: -1.750,
};

// ============================================================================
// DSCR ADVANTAGE PROGRAM (Unchanged - keep existing)
// ============================================================================
export const DSCR_ADVANTAGE_RATES = {
  programName: "DSCR Advantage",
  productTypes: ["30Y Fixed", "5/6 ARM", "7/6 ARM"],
  rateMatrix: {
    "30Y Fixed": [
      { rate: 8.75, price: 105.845 },
      { rate: 8.625, price: 105.595 },
      { rate: 8.5, price: 105.345 },
      { rate: 8.375, price: 105.095 },
      { rate: 8.25, price: 104.845 },
      { rate: 8.0, price: 104.564 },
      { rate: 7.875, price: 104.251 },
      { rate: 7.75, price: 103.939 },
      { rate: 7.625, price: 103.626 },
      { rate: 7.5, price: 103.314 },
      { rate: 7.375, price: 102.939 },
      { rate: 7.25, price: 102.564 },
      { rate: 7.125, price: 102.126 },
      { rate: 7.0, price: 101.689 },
      { rate: 6.875, price: 101.189 },
      { rate: 6.75, price: 100.689 },
      { rate: 6.625, price: 99.564 },
      { rate: 6.5, price: 98.939 },
      { rate: 6.375, price: 98.314 },
      { rate: 6.25, price: 97.626 },
      { rate: 6.125, price: 96.938 },
      { rate: 6.0, price: 96.251 },
      { rate: 5.875, price: 95.501 },
    ],
    "5/6 ARM": [
      { rate: 8.75, price: 106.045 },
      { rate: 8.625, price: 105.795 },
      { rate: 8.5, price: 105.545 },
      { rate: 8.375, price: 105.295 },
      { rate: 8.25, price: 105.045 },
      { rate: 8.0, price: 104.764 },
      { rate: 7.875, price: 104.451 },
      { rate: 7.75, price: 104.139 },
      { rate: 7.625, price: 103.826 },
      { rate: 7.5, price: 103.514 },
      { rate: 7.375, price: 103.139 },
      { rate: 7.25, price: 102.764 },
      { rate: 7.125, price: 102.326 },
      { rate: 7.0, price: 101.889 },
      { rate: 6.875, price: 101.389 },
      { rate: 6.75, price: 100.889 },
      { rate: 6.625, price: 99.764 },
      { rate: 6.5, price: 99.139 },
      { rate: 6.375, price: 98.514 },
      { rate: 6.25, price: 97.826 },
      { rate: 6.125, price: 97.138 },
      { rate: 6.0, price: 96.451 },
      { rate: 5.875, price: 95.701 },
    ],
    "7/6 ARM": [
      { rate: 8.75, price: 105.97 },
      { rate: 8.625, price: 105.72 },
      { rate: 8.5, price: 105.47 },
      { rate: 8.375, price: 105.22 },
      { rate: 8.25, price: 104.97 },
      { rate: 8.0, price: 104.689 },
      { rate: 7.875, price: 104.376 },
      { rate: 7.75, price: 104.064 },
      { rate: 7.625, price: 103.751 },
      { rate: 7.5, price: 103.439 },
      { rate: 7.375, price: 103.064 },
      { rate: 7.25, price: 102.689 },
      { rate: 7.125, price: 102.251 },
      { rate: 7.0, price: 101.814 },
      { rate: 6.875, price: 101.314 },
      { rate: 6.75, price: 100.814 },
      { rate: 6.625, price: 99.689 },
      { rate: 6.5, price: 99.064 },
      { rate: 6.375, price: 98.439 },
      { rate: 6.25, price: 97.751 },
      { rate: 6.125, price: 97.063 },
      { rate: 6.0, price: 96.376 },
      { rate: 5.875, price: 95.626 },
    ],
  },
};

export const DSCR_ADVANTAGE_LLPA = {
  // FICO adjustments
  fico: {
    "780+": 0,
    "760-779": -0.125,
    "740-759": -0.25,
    "720-739": -0.375,
    "700-719": -0.5,
    "680-699": -0.75,
    "660-679": -1.0,
  },
  // Property Type adjustments
  propertyType: {
    "Single Family / Townhome": 0,
    "Condo": -0.125,
    "Short Term Rental": -0.25,
    "2-4 Unit": -0.375,
    "Multi Family (5-9)": -0.5,
  },
  // Loan Purpose adjustments
  loanPurpose: {
    "Purchase": 0,
    "Rate/Term Refinance": 0,
    "Cash-Out Refinance": -0.125,
  },
  // DSCR adjustments
  dscr: {
    ">=1.25": 0,
    "1.00-1.24": -0.25,
    "<1.00": -0.5,
  },
  // Prepayment Penalty adjustments
  prepayPenalty: {
    "No Penalty": 0,
    "12 Months": 0.5,
    "24 Months": 0.55,
    "36 Months": 0.6,
    "48 Months": 0.65,
    "60 Months": 0.7,
  },
  // Loan Amount adjustments
  loanAmount: {
    "<250,000": -0.25,
    "250,000-1,000,000": 0,
    "1,000,001-2,000,000": -0.125,
    "2,000,001-2,500,000": -0.375,
    ">2,500,000": -0.5,
  },
  // Interest Only adjustment
  interestOnly: -0.125,
  // State Tier adjustments (TX/LA/FL/GA/SC/MN/CO/OR/UT/AZ get better pricing)
  stateTier: {
    "tier1": 0, // TX, LA, FL, GA, SC, MN, CO, OR, UT, AZ
    "tier2": -0.25, // Other states
  },
};

// ============================================================================
// DSCR PLUS PROGRAM (Unchanged - keep existing)
// ============================================================================
export const DSCR_PLUS_RATES = {
  programName: "DSCR Plus",
  productTypes: ["30Y Fixed", "10/1 ARM"],
  rateMatrix: {
    "30Y Fixed": [
      { rate: 9.0, price: 104.7 },
      { rate: 8.875, price: 104.305 },
      { rate: 8.75, price: 104.168 },
      { rate: 8.625, price: 103.721 },
      { rate: 8.5, price: 103.245 },
      { rate: 8.375, price: 102.958 },
      { rate: 8.25, price: 102.427 },
      { rate: 8.125, price: 102.092 },
      { rate: 8.0, price: 101.501 },
      { rate: 7.875, price: 101.119 },
      { rate: 7.75, price: 100.73 },
      { rate: 7.625, price: 100.587 },
      { rate: 7.5, price: 100.216 },
      { rate: 7.375, price: 99.995 },
      { rate: 7.25, price: 99.459 },
      { rate: 7.125, price: 99.012 },
      { rate: 7.0, price: 98.292 },
      { rate: 6.875, price: 97.425 },
      { rate: 6.75, price: 96.834 },
      { rate: 6.625, price: 95.964 },
    ],
    "10/1 ARM": [
      { rate: 9.0, price: 102.868 },
      { rate: 8.875, price: 102.543 },
      { rate: 8.75, price: 102.22 },
      { rate: 8.625, price: 101.897 },
      { rate: 8.5, price: 101.574 },
      { rate: 8.375, price: 101.252 },
      { rate: 8.25, price: 100.929 },
      { rate: 8.125, price: 100.608 },
      { rate: 8.0, price: 100.282 },
      { rate: 7.875, price: 99.945 },
      { rate: 7.75, price: 99.596 },
      { rate: 7.625, price: 99.236 },
      { rate: 7.5, price: 98.862 },
      { rate: 7.375, price: 98.475 },
      { rate: 7.25, price: 98.072 },
      { rate: 7.125, price: 97.658 },
      { rate: 7.0, price: 97.236 },
      { rate: 6.875, price: 96.804 },
      { rate: 6.75, price: 96.357 },
      { rate: 6.625, price: 95.898 },
    ],
  },
};

export const DSCR_PLUS_LLPA = {
  // FICO adjustments
  fico: {
    "780+": 0,
    "760-779": -0.125,
    "740-759": -0.25,
    "720-739": -0.375,
    "700-719": -0.5,
    "680-699": -0.75,
    "660-679": -1.0,
  },
  // Property Type adjustments
  propertyType: {
    "Single Family": 0,
    "2-4 Unit": -0.125,
    "Condo": -0.25,
    "Short Term Rental": -0.375,
  },
  // Loan Purpose adjustments
  loanPurpose: {
    "Purchase": 0,
    "Rate/Term Refinance": 0,
    "Cash-Out Refinance": -0.25,
  },
  // DSCR adjustments (DSCR Plus has different tiers)
  dscr: {
    ">=1.25": 0.5,
    "1.00-1.24": 0,
    "<1.00": -0.125,
  },
  // Prepayment Penalty adjustments (different from other programs)
  prepayPenalty: {
    "No Penalty": -1.25,
    "12 Months": -1.0,
    "24 Months": -0.5,
    "36 Months": 0,
    "48 Months": 0.5,
    "60 Months": 1.25,
  },
  // Loan Amount adjustments
  loanAmount: {
    "<250,000": -0.25,
    "250,000-1,000,000": 0,
    "1,000,001-2,000,000": -0.125,
    "2,000,001-2,500,000": -0.375,
    ">2,500,000": -0.5,
  },
  // Interest Only adjustment
  interestOnly: -0.125,
  // State Tier adjustments (NJ/NY/PA get better pricing for Plus)
  stateTier: {
    "tier1": 0, // NJ, NY, PA
    "tier2": -0.5, // Other states
  },
};

// ============================================================================
// LOCK PERIOD AND EXTENSION FEES
// ============================================================================
export const LOCK_PERIOD_ADJUSTMENTS = {
  "15 Days": 0.125,
  "30 Days": 0,
  "45 Days": -0.125,
  "60 Days": -0.25,
  "90 Days": -0.375,
};

export const EXTENSION_FEES = {
  "0 Days": 0,
  "7 Days": 0.125,
  "14 Days": 0.25,
  "21 Days": 0.375,
  "30 Days": 0.5,
};

// ============================================================================
// FIXED FEES
// ============================================================================
export const FIXED_FEES = {
  processingFee: 995,
  underwritingFee: 995,
  documentPreparation: 250,
  floodCertification: 15,
  taxServiceFee: 85,
  wireTransferFee: 35,
};

// ============================================================================
// STATE TIERS
// ============================================================================
export const STATE_TIERS = {
  advantageTier1: ["TX", "LA", "FL", "GA", "SC", "MN", "CO", "OR", "UT", "AZ"],
  plusTier1: ["NJ", "NY", "PA"],
};

// ============================================================================
// ALL PROGRAMS COMBINED
// ============================================================================
export const CHURCHILL_PROGRAMS = {
  "DSCR Base": {
    rates: DSCR_BASE_RATES,
    llpa: DSCR_BASE_LLPA,
    // New LTV-based LLPA matrices
    ficoLtv: {
      single: SINGLE_PROPERTY_FICO_LTV,
      crossed: CROSSED_PROPERTY_FICO_LTV,
    },
    propertyTypeLtv: PROPERTY_TYPE_LTV,
    loanAmountLtv: LOAN_AMOUNT_LTV,
    productPurposeLtv: PRODUCT_PURPOSE_LTV,
    dscrLtv: DSCR_LTV,
    prepayPenaltyLtv: PREPAY_PENALTY_LTV,
  },
  "DSCR Advantage": {
    rates: DSCR_ADVANTAGE_RATES,
    llpa: DSCR_ADVANTAGE_LLPA,
  },
  "DSCR Plus": {
    rates: DSCR_PLUS_RATES,
    llpa: DSCR_PLUS_LLPA,
  },
};

export const PROGRAM_OPTIONS = [
  { value: "DSCR Base", label: "DSCR Base" },
  { value: "DSCR Advantage", label: "DSCR Advantage" },
  { value: "DSCR Plus", label: "DSCR Plus" },
];

// ============================================================================
// DROPDOWN OPTIONS - Updated for new rate sheet
// ============================================================================
export const FICO_OPTIONS = [
  { value: "760+", label: "760+" },
  { value: "740-759", label: "740-759" },
  { value: "720-739", label: "720-739" },
  { value: "700-719", label: "700-719" },
  { value: "680-699", label: "680-699" },
  { value: "660-679", label: "660-679" },
  { value: "FN", label: "Foreign National" },
];

export const PROPERTY_TYPE_OPTIONS = [
  { value: "Single Family", label: "Single Family" },
  { value: "Condo", label: "Condo" },
  { value: "2-4 Unit", label: "2-4 Unit" },
  { value: "Short Term Rental", label: "Short Term Rental (STR)" },
  { value: "Multi Family (up to 10)", label: "Multi Family (up to 10 Units)" },
];

export const COLLATERAL_TYPE_OPTIONS = [
  { value: "single", label: "Single Property" },
  { value: "crossed", label: "Crossed (Multiple Properties)" },
];

export const LOAN_PURPOSE_OPTIONS = [
  { value: "Purchase", label: "Purchase" },
  { value: "Rate/Term Refinance", label: "Refinance (Rate and Term)" },
  { value: "Cash-Out Refinance", label: "Refinance (Cash Out)" },
];

export const DSCR_OPTIONS = [
  { value: ">=1.15", label: "1.15x or Higher" },
  { value: "1.00-1.14x", label: "1.00x - 1.14x" },
  { value: "<1.00x", label: "Below 1.00x (No Ratio)" },
];

export const PREPAY_PENALTY_OPTIONS = [
  { value: "No Penalty", label: "No Prepay Penalty" },
  { value: "12 Months", label: "1 Year (12 Months)" },
  { value: "24 Months", label: "2 Year (24 Months)" },
  { value: "36 Months", label: "3 Year (36 Months)" },
  { value: "48 Months", label: "4 Year (48 Months)" },
  { value: "60 Months", label: "5 Year (60 Months)" },
];

export const LTV_OPTIONS = [
  { value: "50%", label: "50% LTV" },
  { value: "55%", label: "55% LTV" },
  { value: "60%", label: "60% LTV" },
  { value: "65%", label: "65% LTV" },
  { value: "70%", label: "70% LTV" },
  { value: "75%", label: "75% LTV" },
  { value: "80%", label: "80% LTV" },
];

export const LOCK_PERIOD_OPTIONS = [
  { value: "15 Days", label: "15 Days" },
  { value: "30 Days", label: "30 Days" },
  { value: "45 Days", label: "45 Days" },
  { value: "60 Days", label: "60 Days" },
  { value: "90 Days", label: "90 Days" },
];

export const US_STATES = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
  { value: "DC", label: "District of Columbia" },
];

export default CHURCHILL_PROGRAMS;
